export const TRUSTPILOT_REVIEWS_KEY = "$trustpilotReviews";
export const TRUSTPILOT_SCORE_KEY = "$trustpilotScore";
export const TRUSTPILOT_SCORE_STRING_KEY = "$trustpilotScoreString";
export const TRUSTPILOT_LOGO = {
  src: "https://a.storyblok.com/f/176726/300x75/a75f713fc7/tp-logo-tricolor-black-rgb.svg",
  width: 300,
  height: 75,
  alt: "Trustpilot logo",
};
export const GOOGLE_OPTIMIZE_ID = "OPT-K7MK9JL";
